import { CountryEnum } from "@/lib/supabase/supabaseEnums";
import { getCantonFromPostalCode } from "./utils-functions";

export const hasSwissPostalCodes = (country: string | null | undefined) =>
	country === CountryEnum.SWITZERLAND ||
	country === CountryEnum.LIECHTENSTEIN;

export const getLabCountry = (
	organization: { country: string | null } | null | undefined
) => organization?.country || CountryEnum.SWITZERLAND;

export const getCountryFromSwissPostalCode = (
	postalCode: string | null | undefined
) =>
	getCantonFromPostalCode(Number(postalCode)) === "FL"
		? CountryEnum.LIECHTENSTEIN
		: CountryEnum.SWITZERLAND;
